import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { ClassedViewColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-hotelreservationpermittype',
    templateUrl: './hotelreservationpermittype.component.html',
    styleUrls: ['./hotelreservationpermittype.component.scss'],
    standalone: false
})
export class HotelreservationpermittypeComponent extends Busyable implements OnInit {
  public ModelId: any;
  public MapPolygons: any[] = [];
  public Model: any;
  public orgService: OrganizationsService;
  public Columns: Datalistviewcolumn[] = [];

  public MapOptions: google.maps.MapOptions = {
    center: { lat: 40, lng: -20 },
    zoom: 16,
  };

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, organizationService: OrganizationsService) {
    super();
    this.orgService = organizationService;
    this.Columns = [
      new Datalistviewcolumn("Start Date", "StartDateLocalFriendlyString"),
      new Datalistviewcolumn("End Date", "EndDateLocalFriendlyString"),
      new Datalistviewcolumn("Plate Number", "GuestPlateNumber"),
      new Datalistviewcolumn("Guest", "GuestName"),
      new ClassedViewColumn("Status", "CurrentStateName")
    ];
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => {
      this.ModelId = params['id'];
      this.LoadModelAsync();
    });
  }

  private async LoadModelAsync(): Promise<void> {
    try {
      // Reset view state to avoid showing stale data while navigating between IDs.
      this.Model = null;
      this.MapPolygons = [];

      if (!this.ModelId) {
        return;
      }

      this.Model = await this.apiService.Get<any>("permits/hotelreservationpermittypes/" + this.ModelId);

      this.Model.Restriction = this.BuildRestrictionString();
      this.Model.CutoffTimeLocalFriendlyString = this.FormatCutoffTime(this.Model.CutoffTimeLocal);

      if (this.Model["ParkingStructures"] != null) {
        this.Model.ParkingStructures.forEach((ps: any) => {
          let loc = ps["GeoPolygonPoints"];
          if (loc != null) {
            if (loc.length > 0) {
              let poly: google.maps.LatLngLiteral[] = [];
              for (let j = 0; j < loc.length; j++) {
                poly.push({ lat: loc[j][1], lng: loc[j][0] });
              }

              this.MapOptions.center = { lng: poly[0].lng, lat: poly[0].lat };
              this.MapPolygons.push(poly);
            }
          }
        });
      }
    } catch (err) {
      console.error('Error loading hotel reservation permit type:', err);
      this.Model = null;
      this.MapPolygons = [];
    } finally {
      this.StopLoading();
    }
  }

  private FormatCutoffTime(cutoffTimeLocal: string | null): string {
    // Backend sends TimeSpan as "HH:mm:ss" (or "d.HH:mm:ss" if it ever spans days); format to a friendly h:mm AM/PM.
    if (!cutoffTimeLocal) {
      return 'No Cutoff Time';
    }

    const timePart = cutoffTimeLocal.includes('.') ? cutoffTimeLocal.split('.')[1] : cutoffTimeLocal;
    const [hoursStr, minutesStr] = timePart.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    if (isNaN(hours) || isNaN(minutes)) {
      return cutoffTimeLocal;
    }

    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 === 0 ? 12 : hours % 12;
    return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`;
  }

  public BuildRestrictionString() {
    var parts = [];

    if (this.Model.RestrictToUserRoles && this.Model.RoleRestrictions?.length > 0) {
      parts.push("This permit type is restricted to Users who have the User Roles: ");
      for (let i = 0; i < this.Model.RoleRestrictions.length; i++) {
        parts.push((i == 0 ? '' : (i == this.Model.RoleRestrictions.length - 1 ? ', and ' : ',')) + this.Model.RoleRestrictions[i].RoleName);
      }
      parts.push(". ");
    }

    var limitedToPushed = false;

    if (this.Model.RestrictBySpaceType && this.Model.SpaceTypeRestrictions?.length > 0) {
      parts.push(parts.length > 0 ? "It is limited to use in " : "This permit type is limited to use in ");
      limitedToPushed = true;
      for (let i = 0; i < this.Model.SpaceTypeRestrictions.length; i++) {
        parts.push((i == 0 ? '' : (i == this.Model.SpaceTypeRestrictions.length - 1 ? ', and ' : ',')) + "'" + this.Model.SpaceTypeRestrictions[i].SpaceTypeName + "'");
      }
      parts.push(" Parking Spaces");
    }

    if (this.Model.ParkingStructures?.length > 0) {
      if (limitedToPushed) parts.push(" in the following parking structures: ");
      else parts.push(parts.length > 0 ? "It is limited to the following parking structures: " : "This permit type is limited to the following parking structures: ");

      for (let i = 0; i < this.Model.ParkingStructures.length; i++) {
        parts.push((i == 0 ? '' : (i == this.Model.ParkingStructures.length - 1 ? ', and ' : ',')) + "'" + this.Model.ParkingStructures[i].LocationString + "'");
      }
      parts.push(". ");
    }

    var str = parts.join("");
    if (str.trim().length == 0) str = "There are no restrictions on this permit type.";
    return str;
  }
}

